import styled from 'styled-components'

export const StyledLoginForm = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 32px 0;
  width: 100%;
  margin-top: 88px;
  @media (max-height: 768px) {
    margin-top: 60px;
    padding-bottom: 16px;
  }
`

export const LoginPageTitle = styled.div`
  font-family: Inter;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
  color: #202020;
  margin-bottom: 24px;
`
export const BottomNavigation = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;
  justify-content: center;
  position: absolute;
  width: 100%;
  bottom: 24px;
  padding: 0;
  left: 0;
  margin-bottom: 0;
`
export const NavigationLi = styled.li`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-right: 24px;
  color: rgba(32, 32, 32, 0.7);
  cursor: pointer;
  a {
     color: rgba(32, 32, 32, 0.7);
     text-decoration: none;
  }
`
export const LogosImageWrapper = styled.div`
  width: 100%;  
  margin: 53px auto 0 auto;
  @media (max-height: 768px) {
    margin-top: 25px;
  }
`
export const AcknowledgementWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const AcknowledgementText = styled.p`
  color: #202020;
  text-align: center;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  margin: 0;
`
